/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Purpose_5Inputs */

const da_privacy_purpose_5 = /** @type {(inputs: Privacy_Purpose_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brugsstatistik og fejl knyttet til din konto, og feedback om appen: dit samtykke i cookiebanneret, som du kan trække tilbage under »Cookieindstillinger« nederst på siderne (art. 6, stk. 1, litra a). Uden samtykke bruger vi ikke PostHog til andet end at tælle besøg.`)
};

/** @type {(inputs: Privacy_Purpose_5Inputs) => LocalizedString} */
const en_privacy_purpose_5 = da_privacy_purpose_5;

/**

* @param {Privacy_Purpose_5Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_purpose_5 = /** @type {((inputs?: Privacy_Purpose_5Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Purpose_5Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_purpose_5(inputs)
	return /** @type {LocalizedString} */ ("Brugsstatistik og fejl knyttet til din konto, og feedback om appen: dit samtykke i cookiebanneret, som du kan trække tilbage under »Cookieindstillinger« nederst på siderne (art. 6, stk. 1, litra a). Uden samtykke bruger vi ikke PostHog til andet end at tælle besøg.")
});